import React from 'react';

import { useAtom } from 'jotai';
import { useWindowSize } from 'usehooks-ts';

import { rudderstackTrackEvent } from '@/api/rudderstack/client';
import { pageLoading } from '@/lib/store';
import { HotDeal } from '@/modules/core/types';

interface HotDealProps {
  deal: HotDeal;
}

const HotDealCard: React.FC<HotDealProps> = ({ deal }) => {
  const windowSize = useWindowSize();
  const [isLoading] = useAtom(pageLoading);

  const navigateToLink = (link: string) => {
    window.open(link, '_blank');
  };

  function checkos() {
    const userAgent = navigator.userAgent || navigator.vendor;
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return 'iOS';
    }

    return 'web';
  }

  // @ts-ignore
  const track = (event) => {
    rudderstackTrackEvent(event, {
      Id: deal.id,
      platform: checkos(),
    });
  };

  const handleHotDealCardClick = () => {
    navigateToLink(`${deal.attributes.link}`);
    track(`BonPlan-${deal.id}`);
  };

  return (
    <>
      {isLoading ? (
        <div className="w-[350px] h-[250px] bg-slate-200 animate-pulse m-2"></div>
      ) : (
        <>
          {windowSize.width > 425 ? (
            <span onClick={handleHotDealCardClick}>
              <div className="m-2 overflow-hidden transition-transform inline-block rounded-xl">
                <img
                  className="w-max hover:scale-110 duration-500 ease-in-out cursor-pointer rounded-xl"
                  src={`https://strapi-api.tayara.tn${deal?.attributes?.desktopImage?.data?.attributes?.url}`}
                  alt={deal.attributes.title}
                />
              </div>
            </span>
          ) : (
            <span onClick={handleHotDealCardClick}>
              <img
                className="w-max m-2"
                src={`https://strapi-api.tayara.tn${deal?.attributes?.handsetImage?.data?.attributes?.url}`}
                alt={deal.attributes.title}
              />
            </span>
          )}
        </>
      )}
    </>
  );
};

export default HotDealCard;
